const SIGLAS_REGIAO = {
  Norte: 'N',
  Nordeste: 'NE',
  'Centro-Oeste': 'CO',
  Sudeste: 'SE',
  Sul: 'S',
}

const ESTADOS_FEMININOS = ['BA', 'PB']

/**
 * Agrega quantitativos de equipes de uma classificação no formato do cartaz.
 * @param {Object|null} item
 * @returns {string}
 */
export function formatarEquipesClassificacao(item) {
  if (!item) return ''

  const linhas = []
  const esf = Number(item.esf_qual || 0) + Number(item.eap_qual || 0)
  const cvat = Number(item.esf_cvat || 0) + Number(item.eap_cvat || 0)
  const multi = Number(item.emulti_qual || 0)
  const esb = Number(item.esb_qual || 0)

  if (esf > 0) linhas.push(`${esf} eSF`)
  if (cvat > 0) linhas.push(`${cvat} CVAT`)
  if (multi > 0) linhas.push(`${multi} eMulti`)
  if (esb > 0) linhas.push(`${esb} eSB`)

  return linhas.join('\n')
}

/**
 * Texto do pódio BR / faixa populacional (mesma regra do ModalDesempenho).
 * @param {Object} municipio
 * @param {string} [regiao]
 * @returns {string}
 */
export function formatarPosicaoBr(municipio, regiao = '') {
  if (!municipio) return ''

  if (
    regiao &&
    municipio.posicao_faixa_pop < municipio.posicao_br
  ) {
    return `${municipio.posicao_faixa_pop_regiao_ibge}º no ${
      SIGLAS_REGIAO[regiao] || regiao
    } ${municipio.int_faixa_port_pop}K`
  }

  if (municipio.posicao_faixa_pop < municipio.posicao_br) {
    return `${municipio.posicao_faixa_pop}º no BR ${municipio.int_faixa_port_pop}K`
  }

  return `${municipio.posicao_br}º no BR`
}

/**
 * Tema do cartaz a partir da melhor posição.
 * @param {Object} municipio
 * @returns {'ouro'|'prata'|'bronze'|'neutro'}
 */
export function resolverTemaDesempenho(municipio) {
  const regional = Number(municipio?.posicao_regiao_saude || 999)
  const uf = Number(municipio?.posicao_uf || 999)
  const br = Number(municipio?.posicao_br || 999)
  const melhor = Math.min(regional, uf, br)

  if (melhor === 1) return 'ouro'
  if (melhor === 2) return 'prata'
  if (melhor === 3) return 'bronze'
  return 'neutro'
}

/**
 * Monta o objeto de query params para a página do editor.
 * @param {Object} municipio
 * @param {{ page?: string, regiao?: string }} [contexto]
 * @returns {Object}
 */
export function montarQueryCartaz(municipio, contexto = {}) {
  if (!municipio) return {}

  const uf = municipio.uf || ''
  const artigo = ESTADOS_FEMININOS.includes(uf) ? 'na' : 'no'
  const tema = resolverTemaDesempenho(municipio)
  const percentual =
    municipio.desempenho != null && municipio.desempenho !== ''
      ? String(municipio.desempenho).replace('%', '')
      : municipio.notaGeral != null
        ? String(municipio.notaGeral)
        : ''

  const query = {
    ibge: municipio.ibge != null ? String(municipio.ibge) : '',
    municipio: `${municipio.municipio || ''} - ${uf}`.trim(),
    uf,
    quadrimestre: municipio.quadrimestre || '',
    percentual,
    ranking1: `${Number(municipio.posicao_regiao_saude || 0)}º na Regional`,
    ranking2: `${Number(municipio.posicao_uf || 0)}º ${artigo} ${uf}`,
    ranking3: formatarPosicaoBr(municipio, contexto.regiao || ''),
    regular: formatarEquipesClassificacao(municipio.regular),
    suficiente: formatarEquipesClassificacao(municipio.suficiente),
    boa: formatarEquipesClassificacao(municipio.bom),
    otima: formatarEquipesClassificacao(municipio.otimo),
    tema,
    page: contexto.page || '',
  }

  if (contexto.regiao) {
    query.regiao = contexto.regiao
  }

  // Remove vazios para URL mais curta
  Object.keys(query).forEach((key) => {
    if (query[key] === '' || query[key] == null) delete query[key]
  })

  return query
}
